"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creditScore = void 0;

var Actions = _interopRequireWildcard(require("./actions"));

/**
 * Credit score related reducers
 */
var defaultCreditScore = 0;

var creditScore = function creditScore() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultCreditScore;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case Actions.RECEIVE_CREDIT_SCORE:
      return action.creditScore ? action.creditScore : defaultCreditScore;

    default:
      return state;
  }
};

exports.creditScore = creditScore;